import graphics from './graphics';
import utils from './utils';

class Jobs {
    initJobs(container)
    {
        $('form.runs-jobs', container).submit((e) => {
            e.preventDefault();
            let form = $(e.currentTarget);
            graphics.blurForm(form);
            let data = utils.j().serializeForm(form);

            $.ajax({
                url: form.attr('action'),
                method: 'GET',
                data: data,
                dataType: 'HTML',
                success: function(res) {
                    res = $(res);
                    res.modal('show');
                    utils.j().initElements(res);
                    graphics.unblurForm(form);
                }
            });
        });

        $('.status-modal', container).each((index, node) => {
            let modal = $(node);
            let url = modal.attr('data-status-url');
            this.runCheck(modal, url);
        });
    }

    runCheck(modal, url)
    {
        let wants_reload = modal.hasClass('then-reload');

        setTimeout(() => {
            $.ajax({
                method: 'GET',
                url: url,
                dataType: 'JSON',
                success: (data) => {
                    if (Array.isArray(data) == false) {
                        data = [data];
                    }

                    let complete = true;
                    let messages = modal.find('.messages');
                    let progresses = modal.find('.progresses');
                    messages.empty();

                    data.forEach((d, index) => {
                        let bar = progresses.find('.progress:eq(' + index + ')');
                        if (bar.length == 0) {
                            bar = $('<div class="progress mb-1" role="progressbar"><div class="progress-bar" style="width: 0%"></div></div>').appendTo(progresses);
                        }

                        bar.find('.progress-bar').css('width', d.percentage + '%');

                        d.messages.forEach((row) => {
                            messages.append('<li>' + row.message + '</li>');
                        });

                        if (d.percentage == 100) {
                            if (d.status == 'succeeded') {
                                messages.append('<li>OK</li>');
                            }
                        }
                        else {
                            complete = false;
                        }
                    });

                    if (complete) {
                        if (wants_reload) {
                            location.reload();
                        }

                        graphics.unblurAllForms();
                    }
                    else {
                        this.runCheck(modal, url);
                    }
                },
                error: () => {
                    modal.find('.progress-bar').css('width', '0%');

                    let messages = modal.find('.messages');
                    messages.append('<li>ERROR</li>');

                    graphics.unblurAllForms();
                }
            });
        }, 2000);
    }
}

export default Jobs;
